import React from "react";
import {
  ProjectsIcon,
  PersonIcon,
  CompanyIcon,
  CheckboxBlankTogglerIcon,
  RecurringCheckmarkIcon,
  DiscussionIcon,
  NoteIcon,
  EstimatesIcon,
  FolderOutlineIcon,
  InvoicesIcon,
  ImageIcon,
  TaskListIcon,
  NotebookIcon,
  MessageIcon,
  ClockIcon,
  DollarIcon,
  CalendarIcon,
  ProjectTemplateIcon,
  ChecklistIcon,
  CalendarAddXIcon,
} from "@activecollab/components";

export const classTypeIconResolver = (classType) => {
  switch (classType) {
    case "ProjectTemplate":
      return <ProjectTemplateIcon />;
    case "UserCalendar":
      return <CalendarIcon />;
    case "CalendarEvent":
      return <CalendarAddXIcon />;
    case "Folder":
      return <FolderOutlineIcon />;
    case "Comment":
      return <MessageIcon />;
    case "Expense":
      return <DollarIcon />;
    case "TimeRecord":
      return <ClockIcon />;
    case "Subtask":
      return <ChecklistIcon />;
    case "Task":
      return <CheckboxBlankTogglerIcon />;
    case "TaskList":
      return <TaskListIcon />;
    case "Discussion":
      return <DiscussionIcon />;
    case "Project":
      return <ProjectsIcon />;
    case "Note":
      return <NoteIcon />;
    case "Owner":
    case "Member":
    case "Client":
      return <PersonIcon />;
    case "LocalFile":
    case "WarehouseFile":
    case "DropboxFile":
    case "GoogleDriveFile":
      return <ImageIcon />;
    case "Company":
      return <CompanyIcon />;
    case "Estimate":
      return <EstimatesIcon />;
    case "Invoice":
      return <InvoicesIcon />;
    case "RecurringTask":
      return <RecurringCheckmarkIcon />;
    case "ActiveCollab\\Module\\System\\Model\\Folder\\ProjectFolder":
      return <FolderOutlineIcon />;
    case "Notebook":
      return <NotebookIcon />;
    default:
      return "";
  }
};
